import { useTranslation } from 'react-i18next';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Menu } from '../types';

interface SitesTabProps {
  menu: Menu;
}

const SitesTab = ({ menu }: SitesTabProps) => {
  const { t } = useTranslation('menus');

  if (menu.sites.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noSites', 'This menu is not currently assigned to any sites.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('siteName', 'Site')}</TableCell>
            <TableCell>{t('region', 'Region')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {menu.sites.map((site) => (
            <TableRow key={site.siteName}>
              <TableCell>{site.siteName}</TableCell>
              <TableCell>{site.region}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SitesTab;
